import SiteMenus from './SiteMenus'

export default SiteMenus
